import type { StyleSpecification } from 'maplibre-gl';

export type MapMode = 'streets' | 'satellite';

export const STREETS_STYLE = 'https://basemaps.cartocdn.com/gl/positron-gl-style/style.json';

/** Esri World Imagery — free, no API key required, standard choice for satellite in open-source maps. */
export const SATELLITE_STYLE: StyleSpecification = {
  version: 8,
  sources: {
    'esri-satellite': {
      type: 'raster',
      tiles: ['https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
      tileSize: 256,
      maxzoom: 18,
      attribution: 'Esri, Maxar, Earthstar Geographics',
    },
  },
  layers: [{ id: 'esri-satellite-layer', type: 'raster', source: 'esri-satellite' }],
};

export function mapStyleFor(mode: MapMode): string | StyleSpecification {
  return mode === 'satellite' ? SATELLITE_STYLE : STREETS_STYLE;
}
